import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IF360Validator } from "./F360Validator";

@injectable()
export default class F360ComercialValidator implements IF360Validator<string> {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const isComercial = this.userProfileMixin.handleGetUserProfile()?.Perfil
      ? this.userProfileMixin.handleGetUserProfile()?.Perfil === 2
      : false;

    return isComercial;
  }
}
